var map = {
	"./CanvasClear": 116,
	"./CanvasClear.js": 116,
	"./CanvasMove": 117,
	"./CanvasMove.js": 117,
	"./CommandAbstract": 41,
	"./CommandAbstract.js": 41,
	"./ComponentDelete": 118,
	"./ComponentDelete.js": 118,
	"./ComponentDrag": 119,
	"./ComponentDrag.js": 119,
	"./ComponentEnter": 120,
	"./ComponentEnter.js": 120,
	"./ComponentExit": 121,
	"./ComponentExit.js": 121,
	"./ComponentNext": 122,
	"./ComponentNext.js": 122,
	"./ComponentPrev": 123,
	"./ComponentPrev.js": 123,
	"./ComponentStyleClear": 124,
	"./ComponentStyleClear.js": 124,
	"./CopyComponent": 125,
	"./CopyComponent.js": 125,
	"./DeleteComponent": 126,
	"./DeleteComponent.js": 126,
	"./DeviceManager": 127,
	"./DeviceManager.js": 127,
	"./Fullscreen": 128,
	"./Fullscreen.js": 128,
	"./ImportTemplate": 129,
	"./ImportTemplate.js": 129,
	"./LeftButtonPanel": 341,
	"./LeftButtonPanel.js": 341,
	"./MarketplaceCommands": 130,
	"./MarketplaceCommands.js": 130,
	"./MoveComponent": 131,
	"./MoveComponent.js": 131,
	"./OpenAssets": 132,
	"./OpenAssets.js": 132,
	"./OpenBlocks": 133,
	"./OpenBlocks.js": 133,
	"./OpenLayers": 134,
	"./OpenLayers.js": 134,
	"./OpenStyleManager": 135,
	"./OpenStyleManager.js": 135,
	"./OpenTraitManager": 136,
	"./OpenTraitManager.js": 136,
	"./PasteComponent": 137,
	"./PasteComponent.js": 137,
	"./Preview": 138,
	"./Preview.js": 138,
	"./Resize": 139,
	"./Resize.js": 139,
	"./SelectComponent": 26,
	"./SelectComponent.js": 26,
	"./SelectPosition": 61,
	"./SelectPosition.js": 61,
	"./ShowOffset": 140,
	"./ShowOffset.js": 140,
	"./StateManager": 141,
	"./StateManager.js": 141,
	"./StudioCommands": 142,
	"./StudioCommands.js": 142,
	"./StudioLogo": 143,
	"./StudioLogo.js": 143,
	"./SwitchVisibility": 144,
	"./SwitchVisibility.js": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 408;